<template>
  <div class="message" ref="message-list" @scroll="scrollTop">
    <ul v-if="session">
      <div class="loading_more" v-if="loading">
        <i class="el-icon-loading"></i>Loading More Messages...
      </div>
      <li v-for="(item, index) in session.messages" :key="'msg' + index">
        <p class="time">
          <span>{{ item.create_time | formatTime }}</span>
        </p>
        <div class="main" :class="{ self: item.self }" v-if="item.self">
          <div class="text" v-if="item.text_type === 0">{{ item.content }}</div>
          <div class="text_img" v-if="item.text_type === 1">
            <el-image :src="item.content" :preview-src-list="[item.content]">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <!-- <img
            class="avatar"
            width="30"
            height="30"
            :src="item.self ? user.photo : session.covey_user.photo"
          /> -->
        </div>
        <div class="main" :class="{ itself: !item.self }" v-else>
          <!-- <img
            class="avatar"
            width="30"
            height="30"
            :src="item.self ? user.photo : session.covey_user.photo"
          /> -->
          <div class="text" v-if="item.text_type === 0">{{ item.content }}</div>
          <div class="text_img2" v-if="item.text_type === 1">
            <el-image :src="item.content" :preview-src-list="[item.content]">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i></div
            ></el-image>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState({
      // 过滤后的会话列表
      session: (state) => state.chat.session,
      // currentSessionId: (state) => state.chat.currentSessionId,
      // 当前"我"的信息
      sessions: (state) => state.chat.sessions,
      loading: (state) => state.chat.session.loading,
      finished: (state) => state.chat.session.finished,
      page: (state) => state.chat.session.page,
    }),
  },
  data() {
    return {};
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid())
        return moment(val).format("YYYY/MM/DD HH:mm:ss");
      else return "-";
    },
  },
  watch: {
    session: {
      handler(newName, oldName) {
        this.$nextTick(() => {
          if (this.page === 1) {
            //不是滑动到顶部加载的时候
            this.toBottom();
          }
        });
      },
      // immediate: true,
      deep: true,
    },
  },
  methods: {
    //滑动到底部
    // scrollTop 页面滚动的高度，
    // clientHeight 可视区域高度
    // scrollHeight 可滚动内容的高度
    toBottom() {
      const listContainer = this.$refs["message-list"];
      listContainer.scrollTop = listContainer.scrollHeight;
    },
    // 滚动到页面顶部时，请求内容
    scrollTop() {
      this.$store.commit("SET_LOADING", false);
      const listContainer = this.$refs["message-list"];
      let scrollTop = listContainer.scrollTop;
      if (scrollTop == 0 && !this.loading && !this.finished) {
        this.$store.commit("SET_LOADING", true);
        this.$store.commit("SET_PAGE", this.page + 1);
        this.$store
          .dispatch("getChatRecord", { page: this.page })
          .then((res) => {
            if (res.status === "0") {
              this.$store.commit("SET_LOADING", false);
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 5px;
  background-color: #fdecd7;
}
::-webkit-scrollbar-track {
  //轨道部分
  // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #fff;
  border-radius: 5px;
}
.message {
  padding: 10px 16px;
  overflow-y: scroll;
  background-color: #fff;
  .loading_more {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    margin: 7px 0;
    .el-icon-loading {
      margin-right: 5px;
    }
  }
  ul {
    list-style: none;
    margin: 0 !important;
    padding: 0 !important;
  }
  li {
    margin-bottom: 15px;
  }
  .time {
    margin: 7px 0;
    text-align: center;

    > span {
      // display: inline-block;
      // padding: 0 18px;
      // font-size: 12px;
      // color: #fff;
      // border-radius: 2px;
      // background-color: #dcdcdc;
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(32, 16, 2, 0.06);
    }
  }
  .avatar {
    float: left;
    margin: 0 10px 0 0;
    border-radius: 3px;
  }
  .main {
    // // width: 80%;
    // .text_img {
    //   background-color: #f7f6f6;
    // }
    .text_img2 {
      display: inline-block;
      position: relative;
      padding: 10px;
      box-sizing: border-box;
      // background-color: #f7f6f6;
      // background-color: #f7f6f6;
      border-radius: 4px;
      .el-image {
        width: 80px;
        height: 80px;
        .el-icon-picture-outline {
          font-size: 30px;
        }
      }
    }
  }
  .text {
    display: inline-block;
    position: relative;
    padding: 0 10px;
    box-sizing: border-box;
    max-width: 70%;
    min-height: 30px;
    line-height: 2.5;
    font-size: 14px;
    text-align: left;
    word-break: break-all;
    background-color: #f7f6f6;
    border-radius: 4px;

    // &:before {
    //   content: " ";
    //   position: absolute;
    //   top: 9px;
    //   right: 100%;
    //   border: 6px solid transparent;
    //   border-right-color: #fafafa;
    // }
  }

  .itself {
    display: flex;
    justify-content: flex-start;
  }
  .self {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    .avatar {
      float: right;
      margin: 0 0 0 10px;
    }
    .text_img {
      display: inline-block;
      position: relative;
      padding: 10px;
      box-sizing: border-box;
      // background-color: #fdecd7;
      // background-color: #f7f6f6;
      border-radius: 4px;
      .el-image {
        width: 80px;
        height: 80px;
        .el-icon-picture-outline {
          font-size: 30px;
        }
      }
    }
    .text {
      // width: 80%;
      background-color: #fdecd7;
      // &:before {
      //   right: inherit;
      //   left: 100%;
      //   border-right-color: transparent;
      //   border-left-color: #b2e281;
      // }
    }
  }
}
</style>